// a single source of truth for hardcoded pooja listings

export const poojaTypesData = [
  {
    id: 'daily',
    icon: 'fas fa-hands-praying',
    title: 'Daily Pooja',
    description: 'Regular daily prayers for spiritual well-being.',
    price: 299, 
    featured: false,
    filters: {
      deity: ['Vishnu', 'Shiva'],
      tithis: ['Ekadashi', 'Pradosh'],
      dosha: ['General'],
      benefits: ['Spiritual progress', 'Good health', 'Harmony in family'],
      location: ['Jagannath Temple, Puri', 'Kashi Vishwanath Temple, Varanasi']
    }
  },
  {
    id: 'special',
    icon: 'fas fa-om',
    title: 'Special Occasion Pooja',
    description: 'Customized pooja for birthdays, anniversaries, etc.',
    price: 599,
    featured: true,
    filters: {
      deity: ['Ganesha', 'Lakshmi', 'Mahalakshmi', 'Kubera', 'Parvati', 'Katyayani'],
      tithis: ['Purnima', 'Auspicious Muhurat'],
      dosha: ['General', 'Mangal Dosha'],
      benefits: ['Professional and career growth', 'Happy marriage and love relationships', 'Fulfillment of desires'],
      location: ['Lingaraj Temple, Bhubaneswar', 'Maa Bagalamukhi Temple, Puri']
    }
  },
  {
    id: 'festival',
    icon: 'fas fa-moon',
    title: 'Festival Pooja',
    description: 'Ceremonies for major Hindu festivals.',
    price: 799,
    featured: false,
    filters: {
      deity: ['Durga', 'Kali', 'Ganesha', 'Guru'],
      tithis: ['Navratri', 'Amavasya', 'Chaturthi'],
      dosha: ['General'],
      benefits: ['Blessings of Navgrahas', 'Protection from negativity', 'Spiritual progress'],
      location: ['Jagannath Temple, Puri', 'Chandi Temple, Cuttack']
    }
  },
  {
    id: 'remedial',
    icon: 'fas fa-heart',
    title: 'Remedial Pooja',
    description: 'To overcome obstacles and bring positive energy.',
    price: 999,
    featured: false,
    filters: {
      deity: ['Hanuman', 'Shani', 'Bagalamukhi', 'Shiva', 'Rudra', 'Navgraha'],
      tithis: ['Amavasya', 'Saturday Muhurat'],
      dosha: ['Shani Dosha', 'Rahu-Ketu Dosha', 'Pitru Dosha', 'Mangal Dosha', 'Kaal Sarp Dosha'],
      benefits: ['Obstacles removal', 'Relief from malefic effects of planets in horoscope', 'Victory over Enemies', 'Victory in court cases'],
      location: ['Mangalnath Temple, Ujjain', 'Maa Bagalamukhi Temple, Puri']
    }
  },
  {
    id: 'house-warming',
    icon: 'fas fa-home',
    title: 'House Warming Pooja',
    description: 'Sacred ceremony for blessing new homes.',
    price: 1299,
    featured: false,
    filters: {
      deity: ['Ganesha', 'Vastu Purusha'],
      tithis: ['Griha Pravesh Muhurat'],
      dosha: ['Vastu Dosha'],
      benefits: ['Harmony in family', 'Good health', 'Wealth and Prosperity'],
      location: ['Lokanath Temple, Puri', 'Kashi Vishwanath Temple, Varanasi']
    }
  },
  {
    id: 'success',
    icon: 'fas fa-graduation-cap',
    title: 'Success Pooja',
    description: 'For academic success and career growth.',
    price: 699,
    featured: false,
    filters: {
      deity: ['Saraswati', 'Ganesha', 'Guru'],
      tithis: ['Vasant Panchami', 'Guru Pushya'],
      dosha: ['Mercury Dosha'],
      benefits: ['School and college performance', 'Creativity growth', 'Professional and career growth', 'Meditation/Yoga rituals'],
      location: ['Tarini Temple', 'Bhubaneswari Temple, Bhubaneswar']
    }
  }
];

// A helper to easily find a pooja by its ID
export const getPoojaById = (id) => poojaTypesData.find(p => p.id === id);
